<template>
  <div :class="['audit-log-item', { clickable }]" @click.stop.prevent="handleClick">
    <align flex>
      <div>
        <div class="log-time">
          {{ $filters.datetime(log.date) }}
        </div>
        <div v-if="employeeLabel" class="log-time">
          {{ employeeLabel }}
        </div>
        <div v-if="log.label" class="log-label">
          <b>{{ log.label }}</b>
        </div>
        <div>{{ description }}</div>
      </div>

      <div>
        <icon-button
          v-if="hasChanges"
          :icon="expanded ? 'expand_less' : 'expand_more'"
          @click.stop.prevent="expanded = !expanded"
        />
      </div>
    </align>

    <section v-show="expanded" class="changes">
      <div v-for="(change, i) in changes" :key="i">
        <div><b>{{ change.label }}</b></div>
        <div class="change-before">
          <span>{{ change.beforeValue }}</span>
        </div>
        <div><span>{{ change.afterValue }}</span></div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    log: Object,
  },

  data() {
    return {
      expanded: false,
    };
  },

  computed: {
    ...mapState({
      employeeOptions: (state) => state.employeeOptions,
    }),

    clickable() {
      return Boolean(this.log.cardId);
    },

    hasChanges() {
      return this.log.changes && Object.keys(this.log.changes).length;
    },

    employeeLabel() {
      if (!this.log.uid) {
        return null;
      }

      return this.employeeOptions.find(({ value }) => value === this.log.uid).label;
    },

    changes() {
      if (!this.hasChanges) {
        return [];
      }

      return Object.keys(this.log.changes).map((changeKey) => {
        return {
          label: changeKey,
          beforeValue: this.log.changes[changeKey].before,
          afterValue: this.log.changes[changeKey].after,
        };
      });
    },

    description() {
      let description = '';

      switch (this.log.type) {
        case 'CARD_UPDATE':
          description = 'Card updated';
          break;
        case 'CARD_CREATE':
          description = 'Card created';
          break;
        case 'CARD_STATUS_CHANGE':
          description = 'Card status changed';
          break;
        case 'CARD_STATUS_REVIEW':
          description = 'Card moved into review';
          break;
        case 'CARD_STATUS_BACK_TO_PROGRESS':
          description = 'Card moved back into progress from review';
          break;
        case 'CARD_ADMIT':
          description = 'Card admitted to the database';
          break;
        case 'CARD_DELETE':
          description = 'Card deleted';
          break;
        case 'CARD_EBAY_SCRAPE':
          description = 'Card sales scrape on eBay started';
          break;
        case 'CARD_INITIAL_SALES_SCRAPE':
          description = 'Card initial sales scrape started';
          break;
        case 'CARD_POP_UPDATE':
          description = 'Card pop update started';
          break;
        case 'CARD_SYNC_DAILY_SALES':
          description = 'Card daily sales sync started';
          break;
        case 'CARD_UPDATE_STATS':
          description = 'Card stats update started';
          break;
        case 'PENDING_SALE_APPROVED':
          description = 'Pending sale approved';
          break;
        case 'PROFILE_MATCHED_MANUAL':
          description = 'Profile match completed manually';
          break;
        case 'PROFILE_MATCHED_AUTOMATIC':
          description = 'Profile match completed automatically';
          break;
        case 'PROFILE_SET_MATCH_SUGGESTED':
          description = 'Set-match suggestions loaded';
          break;

        default:
          description = this.log.type;
      }

      return description;
    },
  },

  methods: {
    handleClick() {
      if (this.log.cardId) {
        this.$router.push({ query: { ...this.$route.query, cardId: this.log.cardId }});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.audit-log-item {
  padding: $gp;
  border-bottom: solid 1px var(--theme-border);

  &.clickable {
    cursor: pointer;

    &:hover {
      background-color: var(--theme-highlight);
    }
  }
}

.log-label {
  margin-top: $gp * .5;
}

.log-time {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.5;
  letter-spacing: 1px;
}

.changes {
  margin-top: $gp;
}

.change-before {
  margin-bottom: $gp * .5;
}
</style>
